module.exports = __webpack_public_path__ + "img/feature-interactive-kiosks.3df1e8fd.webp";